import React from 'react';
import UsersContext, { UsersStore } from './UsersContext';
import styled from 'styled-components';
import UsersList from './UsersList';
import UsersDetails from './UsersDetails';
import UsersAddModal from './UsersAddModal';
import UserConfirmDeleteDialog from './UserConfirmDeleteDialog';
import EmptyStateMessage from '../common/EmptyStateMessage';

const Container = styled.div`
    display:grid;
    grid-template-columns: 240px 1px 1fr;
`;

const ListContainer = styled.div`
   background-color:white;
`;

const Divider = styled.div`
   background-color:black;
`;

const DetailsContainer = styled.div`
    background-color:#f5f5f5;
    display:flex;
    align-items:start;
    justify-content:center;
    padding-top:88px;
    width:100%;
    overflow-x:auto;

    @media (max-width: 1100px) {
        justify-content:left;
      }
`;


const UsersMain = props => {
    return (
        <UsersStore>
            <UsersContext.Consumer>
                {context => {

                    if (context.aboutCurrentUser) {
                        if (context.aboutCurrentUser.isAdmin === true) {


                            return <>
                                <Container style={{ height: context.contentHeight }}>
                                    <ListContainer>
                                        <UsersList />
                                    </ListContainer>
                                    <Divider />
                                    <DetailsContainer>
                                        <UsersAddModal />
                                        {context.users.selectedUserDetails &&
                                            <UsersDetails />
                                        }
                                    </DetailsContainer>
                                </Container>
                                <UserConfirmDeleteDialog />

                            </>
                        } else {
                            return <EmptyStateMessage>
                                You do not have permission to view this page.
                            </EmptyStateMessage>

                        }

                    } else {
                        return null;
                    }

                }}
            </UsersContext.Consumer>

        </UsersStore>
    )
}

export default UsersMain;